import {ON_PASSWORD_POLICY_LIST,ON_PASSWORD_POLICY_ADD,ON_PASSWORD_POLICY_UPDATE} from '../constants/ActionTypes';

const INIT_STATE = {
    passwordpolicyList: [],
   
};


export default (state=INIT_STATE,action) => {
    switch (action.type){

        case ON_PASSWORD_POLICY_LIST: {
            return {...state, passwordpolicyList: action.payload};
        }
        
       
        default:
            return state;
    }
}
